import { Calendar, Users, ShieldCheck, Settings, Award, Heart, Sparkles } from 'lucide-react';

export const features = [
  {
    title: "+10 års erfaring",
    description: "Vi har arrangeret golfrejser i over et årti og kender hver en krog af de spanske baner.",
    icon: Award
  },
  {
    title: "+500 glade kunder",
    description: "Over 500 golfspillere har rejst med os – mange vender tilbage år efter år.",
    icon: Users
  },
  {
    title: "Personlig service",
    description: "Vi er et lille firma drevet af et ægtepar, der selv er pensionister og elsker golf.",
    icon: Heart
  },
  {
    title: "De bedste sæsoner",
    description: "Vi arrangerer ophold i de skønneste måneder: okt-dec og jan-mar.",
    icon: Calendar
  }
];

export const contactInfo = {
  phone: "22 46 77 22",
  email: "info@golf4life.dk",
  address: "Cádiz, Spanien / Danmark"
};

export const navigation = [
  { name: 'Forside', href: '/' },
  { name: 'Ophold', href: '/ophold' },
  { name: 'Begivenheder', href: '/begivenheder' },
  { name: 'Om os', href: '/om-os' },
  { name: 'Billeje', href: '/billeje' },
  { name: 'Galleri', href: '/galleri' },
  { name: 'Destination', href: '/#destination' },
  { name: 'Kontakt', href: '/kontakt' }
];
